//@ts-check

class BuildingDocumentsDataService {
	constructor($http, Utility, $timeout, $rootScope, ContentService, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.ContentService = ContentService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.documentsData = null;
		this.InternalLinksService.getLinks('/api/documents/links');
	}

	async getBuildingDocuments(schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('DocumentsApiAll');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/documents/links');
				url = await this.InternalLinksService.getLink('DocumentsApiAll');
			}

			if (!schemeRef) {
				throw new Error('No Building reference provided...');
			}

			const headers = this.Utility.headersWithContentType;
			url = url.replace('{schemeRef}', schemeRef).trim();

			const results = await this.$http.get(url, { headers });
			const documents = {
				BuildingDocuments: results.hasOwnProperty('data') ? results.data : null
			};

			this.documentsData = documents;
			this.$timeout(() => promiseHandler.resolve(documents));
		} catch (error) {
			const documents = {
				BuildingDocuments: []
			};

			this.documentsData = documents;
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async getDocumentById(documentId) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('DocumentsApiById');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/documents/links');
				url = await this.InternalLinksService.getLink('DocumentsApiById');
			}

			if (!documentId) {
				throw new Error('No document ID provided...');
			}

			url = url + documentId;

			const results = await this.$http.get(url);
			const document = results.hasOwnProperty('data') ? results.data : null;

			this.$timeout(() => promiseHandler.resolve(document));
		} catch (error) {
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async loadContent() {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const content = await this.ContentService.load('DocumentsContent', '/api/documents/links');
			this.$timeout(() => promiseHandler.resolve(content));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}
}

export default /* @ngInject */ (
	$http,
	Utility,
	$timeout,
	$rootScope,
	ContentService,
	LocalStorageService,
	InternalLinksService
) =>
	new BuildingDocumentsDataService(
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		LocalStorageService,
		InternalLinksService
	);
